/**
 * PKCE (Proof Key for Code Exchange) utilities for OAuth.
 * Required by Microsoft when using SPA platform with cross-origin token redemption.
 */
export const PKCE_VERIFIER_KEY = 'oauth_pkce_verifier_microsoft'

export function generateCodeVerifier(): string {
  const array = new Uint8Array(32)
  crypto.getRandomValues(array)
  return base64UrlEncode(array)
}

export async function generateCodeChallenge(verifier: string): Promise<string> {
  const encoder = new TextEncoder()
  const data = encoder.encode(verifier)
  const hashBuffer = await crypto.subtle.digest('SHA-256', data)
  return base64UrlEncode(new Uint8Array(hashBuffer))
}

function base64UrlEncode(buffer: Uint8Array): string {
  const base64 = btoa(String.fromCharCode(...buffer))
  return base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '')
}
